import IPaginator from "./Paginator";
import * as Yup from "yup"


export enum IDocumentStatus {
  None = 'None',
  Uploading = "Uploading",
  Uploaded = "Uploaded",
  Processing = "Processing",
  Released = "Released",
  Completed = "COMPLETED"
}

export enum IDocumentSecurityType {
  Private = 'Private',
  Public = 'Public',
  None = 'None'
}


export enum ISlideType {
  none = 'NONE',
  link = "LINK",
  html = "HTML"
}

/*export interface IDocumentFilter {
  contentTypes: Array<string>,   
  category: string,
  customerStage?: number,
  isSharable: boolean,       
  searchTerm?: string,
  sortBy?: string
}*/

export const DOC_FILTER_SCHEMA = Yup.object({
  contentTypes: Yup.array().of(Yup.string()).default([]).defined(),
  category: Yup.string().default('').defined(),
  customerStage: Yup.number().default(0).defined(),
  isSharable: Yup.boolean().default(false).defined(),
  searchTerm: Yup.string().default('').defined(),
  sortBy: Yup.string().default('name').defined()
}).defined();

export type IDocumentFilter = Yup.InferType<typeof DOC_FILTER_SCHEMA>;

export const newDocFilterInstance = ():IDocumentFilter => {
  const obj =  DOC_FILTER_SCHEMA.cast();
  return Object.assign({},obj);
}

export interface IDocumentCollection {
  documents: Array<IDocument>,
  paginator: IPaginator,
}

export const FILE_SCHEMA = Yup.object({
  fileName: Yup.string().required("Upload a file. Filename is required").min(1),
  extension: Yup.mixed().oneOf(['doc', 'docx', 'pdf', 'ppt', 'pptx']).nullable(),
  docUrl: Yup.string(),
  //handle: Yup.string(),
  mimeType: Yup.string(),
  noOfPages: Yup.number().defined().default(0),
  size: Yup.number(),
  status: Yup.mixed().oneOf(Object.values(IDocumentStatus)).default(IDocumentStatus.None),
  conversionStatus: Yup.string().default("NONE"),
  thumbPageNo: Yup.number().defined().default(0),
  thumbUrl: Yup.string().default(''),
  dimension: Yup.object({
    width: Yup.number().default(0),
    height: Yup.number().default(0)
  }),
  pages: Yup.array().of(Yup.object({
    id: Yup.number(),
    url: Yup.string()
  }))
}).defined();


export const WHO_SCHEMA = Yup.object({
  createdOn: Yup.date().default(() => new Date()).transform(function (value, originalvalue) {
    //return this.isType(value) ? new Date(originalvalue._seconds): value;//TODO
    return new Date()
  }),
  owner: Yup.object({
    uid: Yup.string().default(() => {
      return 'anonymous'
    }),
    displayName: Yup.string().defined().default(() => {
      return 'anonymous'
    }),
    imageUrl: Yup.string().default(() => {
      return '';
    })
  }).defined()
}).defined();

export const DOC_SCHEMA = Yup.object({
  uid: Yup.string(),
  name: Yup.string().required().min(1).default(''),
  description: Yup.string().required("Enter a description").default(''),
  category: Yup.string().required('Please select a category.').min(1).default(''),
  contentType: Yup.string().default(''),
  coverTemplate: Yup.string().defined(),
  shareable: Yup.boolean().default(false),
  isActive: Yup.boolean().default(true),
  customerStage: Yup.string().default(''),
  readTime: Yup.number().default(0) ,
  tags: Yup.array().of(Yup.string()).defined().default([]),

  file: FILE_SCHEMA,
  who: WHO_SCHEMA
}).defined();

type IDocument = Yup.InferType<typeof DOC_SCHEMA>;

export const newDocInstance = ():IDocument => {
  const obj =  DOC_SCHEMA.cast();
  return Object.assign({},obj);
}

export const newFileInstance = () => {
  return Object.assign({}, FILE_SCHEMA.cast());
}

export const isDocValid = async (doc:IDocument) => {
  const valid:boolean =  await DOC_SCHEMA.isValid(doc);
  return valid;
}

export const validateDoc = async (doc:IDocument) => {
  let errors:any = {};
  try{
    const err:any = await DOC_SCHEMA.validate(doc, {abortEarly: false});
  }catch(err){
    errors= err.inner.reduce((obj:any, item:any) => {
      obj[item.path] = item.message;
      return obj;
    }, {});
  }
  return errors;
}

export const convertToDoc = (doc:any):IDocument => {
  return DOC_SCHEMA.cast(doc);
}

export default IDocument;